import * as BullseyeAPI from '../services/BullseyeAPIService'

// Function that pulls the 3 generation pedigree from the report server and opens the report in a new window
export async function pullThreeGenPedigree(registrationID) {
    var windowReference = window.open('', '_blank');
    BullseyeAPI.get3GenPedigree(registrationID).then((res) => {
        windowReference.location.assign(`https://infojersey.usjersey.com/publictools/remotereport.aspx?${res.data}`);
    })
}